import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { debounce } from '@beef/utils';
import { END_TEXT, HELLO_TEXT, mappedMessangerData } from "../config";
import { getDetailsUrlPage } from "../lib";
import { AuthTypeAnalytics, YM_ID, chatAction, chatAnalyticsAction, chatErrorAction, chatIconAction, viewChatItemAction, ymGoal } from "./constants";
import { executeIfTrue, getHref, getIsNonStartAnswerMes, setStageAnswerMes } from "./utils";
var checkAnalyticsCanBeSended = function checkAnalyticsCanBeSended() {
  return typeof window !== 'undefined' && typeof window.ym === 'function';
};
var ymPushParams = executeIfTrue(checkAnalyticsCanBeSended, function () {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  window.ym(YM_ID, 'params', payload);
});
var ymPushReachGoal = executeIfTrue(checkAnalyticsCanBeSended, function (goal) {
  window.ym(YM_ID, 'reachGoal', goal);
});
var ymPushSupportParams = function ymPushSupportParams() {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return ymPushParams({
    support: payload
  });
};
var ymPushChatParams = function ymPushChatParams() {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return ymPushParams({
    chat: payload
  });
};
var ymPushAttachParams = function ymPushAttachParams() {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return ymPushParams({
    chat_attach: payload
  });
};

// icon actions
var ymPushChatIconAction = function ymPushChatIconAction(action, params) {
  return ymPushSupportParams(_defineProperty({}, chatAnalyticsAction.chatIconAction, _defineProperty({}, action, params)));
};
export var ymPushChatIconOpen = function ymPushChatIconOpen() {
  ymPushChatIconAction(chatIconAction.open, getHref());
};
export var ymPushChatIconHide = function ymPushChatIconHide() {
  ymPushChatIconAction(chatIconAction.hide, getHref());
};
export var ymPushMessangerButton = function ymPushMessangerButton(messenger) {
  ymPushChatIconAction(chatIconAction.start, _defineProperty({}, messenger, getHref()));
};
export var ymPushChatScreenViewed = function ymPushChatScreenViewed() {
  ymPushSupportParams({
    screen_view: {
      chat: getHref()
    }
  });
};

// chat actions
var ymPushChatAction = function ymPushChatAction(action, params) {
  return ymPushSupportParams(_defineProperty({}, chatAnalyticsAction.chatAction, _defineProperty({}, action, params)));
};
export var ymPushStartTyping = function ymPushStartTyping() {
  ymPushChatAction(chatAction.startTyping, getHref());
};
export var ymPushSendMessage = function ymPushSendMessage() {
  ymPushChatAction(chatAction.sendMessage, getHref());
};
export var ymPushChatStart = function ymPushChatStart() {
  return ymPushReachGoal(ymGoal.WebChatStart);
};
export var ymPushTapFaq = function ymPushTapFaq(faqName) {
  ymPushChatAction(chatAction.tapFaq, _defineProperty({}, faqName, getHref()));
};
export var ymPushThreeDotsMenuViewed = function ymPushThreeDotsMenuViewed() {
  ymPushChatAction(chatAction.viewMenu, getHref());
};
export var ymPushThreeDotsMenuTap = function ymPushThreeDotsMenuTap(menuName) {
  ymPushChatAction(chatAction.tapMenu, _defineProperty({}, menuName, getHref()));
};
export var ymPushCloseChat = function ymPushCloseChat() {
  ymPushChatAction(chatAction.closeChat, getHref());
};

// view item
var ymPushViewChatItem = function ymPushViewChatItem(action, params) {
  ymPushSupportParams(_defineProperty({}, chatAnalyticsAction.viewItem, _defineProperty({}, action, params)));
};
export var ymPushTroubleNotificationViewed = function ymPushTroubleNotificationViewed(notificationText) {
  if (typeof notificationText === 'string' && notificationText.length > 0) {
    ymPushViewChatItem(viewChatItemAction.troubleNotificationViewed, _defineProperty({}, notificationText.slice(0, 100), getHref()));
  }
};
export var ymPushFaqItemViewed = function ymPushFaqItemViewed(faqNames) {
  ymPushViewChatItem(viewChatItemAction.faqViewed, [].concat(_toConsumableArray(faqNames.map(function (name) {
    return {
      faq: name
    };
  })), [{
    URL: getHref()
  }]));
};

// error
var ymPushChatError = function ymPushChatError(error, params) {
  ymPushSupportParams(_defineProperty({}, chatAnalyticsAction.chatError, _defineProperty({}, error, params)));
};
export var ymPushSocketConnectionError = function ymPushSocketConnectionError() {
  ymPushChatError(chatErrorAction.socketConnectionFailed, getHref());
};
export var ymPushMessageNotSent = function ymPushMessageNotSent() {
  ymPushChatError(chatErrorAction.messageNotSent, getHref());
};
var getAuthTypeAnalytics = function getAuthTypeAnalytics(zoneType) {
  return zoneType === 'authorized' ? AuthTypeAnalytics.az : AuthTypeAnalytics.nz;
};
var ymPageSharedData = function ymPageSharedData() {
  var _getDetailsUrlPage = getDetailsUrlPage(),
    path = _getDetailsUrlPage.path,
    title = _getDetailsUrlPage.title,
    url = _getDetailsUrlPage.url;
  return {
    page_title: title,
    page_path: path,
    page_url: url
  };
};
export var ymPushClickChatOpen = function ymPushClickChatOpen(zoneType) {
  ymPushChatParams(_objectSpread(_objectSpread({}, ymPageSharedData()), {}, {
    account_type: getAuthTypeAnalytics(zoneType),
    action: chatAnalyticsAction.click,
    item_type: 'icon',
    icon_name: 'chat',
    object_type: 'floating'
  }));
};
export var ymPushClickChatClose = function ymPushClickChatClose(zoneType) {
  ymPushChatParams(_objectSpread(_objectSpread({}, ymPageSharedData()), {}, {
    account_type: getAuthTypeAnalytics(zoneType),
    action: chatAnalyticsAction.click,
    action_type: chatAnalyticsAction.close,
    item_type: 'popup',
    popup_name: 'chat'
  }));
};
export var ymPushChatView = function ymPushChatView(zoneType) {
  ymPushChatParams(_objectSpread(_objectSpread({}, ymPageSharedData()), {}, {
    account_type: getAuthTypeAnalytics(zoneType),
    action: chatAnalyticsAction.view,
    item_type: 'popup',
    popup_name: 'chat',
    object_type: 'floating'
  }));
};
export var ymPushClickChatInput = function ymPushClickChatInput(zoneType) {
  ymPushChatParams(_objectSpread(_objectSpread({}, ymPageSharedData()), {}, {
    account_type: getAuthTypeAnalytics(zoneType),
    action: chatAnalyticsAction.click,
    item_type: 'field',
    field_name: 'Ваше сообщение',
    popup_name: 'chat',
    object_type: 'popup'
  }));
};
export var ymPushChatWord = debounce(3000, function (zoneType) {
  ymPushChatParams(_objectSpread(_objectSpread({}, ymPageSharedData()), {}, {
    account_type: getAuthTypeAnalytics(zoneType),
    action: chatAnalyticsAction.fill_in,
    item_type: 'field',
    field_name: 'Ваше сообщение',
    popup_name: 'chat',
    object_type: 'popup'
  }));
});
export var ymPushMenuView = function ymPushMenuView(zoneType) {
  ymPushChatParams(_objectSpread(_objectSpread({}, ymPageSharedData()), {}, {
    account_type: getAuthTypeAnalytics(zoneType),
    action: chatAnalyticsAction.view,
    item_type: 'widget',
    widget_title: 'ответим везде'
  }));
};
export var ymPushNavigationItemClick = function ymPushNavigationItemClick(item, zoneType) {
  ymPushChatParams(_objectSpread(_objectSpread({}, ymPageSharedData()), {}, {
    account_type: getAuthTypeAnalytics(zoneType),
    action: chatAnalyticsAction.click,
    item_type: 'element',
    element_text: typeof item === 'string' ? mappedMessangerData[item] : item.title,
    widget_title: 'ответим везде'
  }));
};
export var ymPushViewChatError = function ymPushViewChatError(zoneType) {
  ymPushChatParams(_objectSpread(_objectSpread({}, ymPageSharedData()), {}, {
    account_type: getAuthTypeAnalytics(zoneType),
    action: chatAnalyticsAction.view,
    action_type: chatAnalyticsAction.error,
    error_title: 'Что-то пошло не так',
    error_code: null,
    popup_name: 'chat',
    object_type: 'popup'
  }));
};
export var ymPushClickChatError = function ymPushClickChatError(zoneType) {
  ymPushChatParams(_objectSpread(_objectSpread({}, ymPageSharedData()), {}, {
    account_type: getAuthTypeAnalytics(zoneType),
    action: chatAnalyticsAction.click,
    item_type: 'button',
    button_text: 'Повторить',
    action_type: chatAnalyticsAction.error,
    error_title: 'Что-то пошло не так',
    error_code: null,
    popup_name: 'chat',
    object_type: 'popup'
  }));
};
export var ymPushClickErrorIcon = function ymPushClickErrorIcon(zoneType) {
  ymPushChatParams(_objectSpread(_objectSpread({}, ymPageSharedData()), {}, {
    account_type: getAuthTypeAnalytics(zoneType),
    action: chatAnalyticsAction.click,
    item_type: 'icon',
    icon_name: 'error',
    popup_name: 'chat',
    object_type: 'popup'
  }));
};
export var ymPushViewErrorSend = function ymPushViewErrorSend(zoneType) {
  ymPushChatParams(_objectSpread(_objectSpread({}, ymPageSharedData()), {}, {
    account_type: getAuthTypeAnalytics(zoneType),
    action: chatAnalyticsAction.view,
    action_type: chatAnalyticsAction.error,
    item_type: 'icon',
    icon_name: 'error',
    popup_name: 'chat',
    object_type: 'popup'
  }));
};
export var ymPushSendStartMes = function ymPushSendStartMes(zoneType) {
  ymPushChatParams(_objectSpread(_objectSpread({}, ymPageSharedData()), {}, {
    account_type: getAuthTypeAnalytics(zoneType),
    action: chatAnalyticsAction.click,
    item_type: 'icon',
    icon_name: 'send',
    popup_name: 'chat',
    object_type: 'popup'
  }));
};
export var ymPushViewErrorContextMenu = function ymPushViewErrorContextMenu(zoneType) {
  ymPushChatParams(_objectSpread(_objectSpread({}, ymPageSharedData()), {}, {
    account_type: getAuthTypeAnalytics(zoneType),
    action: chatAnalyticsAction.view,
    item_type: 'list',
    list_name: 'опции',
    popup_name: 'chat',
    object_type: 'popup'
  }));
};
export var ymPushClickErrorContextMenu = function ymPushClickErrorContextMenu(zoneType, textBtn) {
  ymPushChatParams(_objectSpread(_objectSpread({}, ymPageSharedData()), {}, {
    account_type: getAuthTypeAnalytics(zoneType),
    action: chatAnalyticsAction.click,
    item_type: 'element',
    element_title: textBtn,
    list_name: 'опции'
  }));
};
export var ymPushViewHelloCaptchaMes = function ymPushViewHelloCaptchaMes(zoneType) {
  ymPushChatParams(_objectSpread(_objectSpread({}, ymPageSharedData()), {}, {
    account_type: getAuthTypeAnalytics(zoneType),
    action: chatAnalyticsAction.view,
    item_type: 'step',
    step: 'приветственное сообщение',
    popup_name: 'chat',
    object_type: 'popup'
  }));
};
export var ymPushViewCaptcha = function ymPushViewCaptcha(zoneType) {
  ymPushChatParams(_objectSpread(_objectSpread({}, ymPageSharedData()), {}, {
    account_type: getAuthTypeAnalytics(zoneType),
    action: chatAnalyticsAction.view,
    item_type: 'element',
    element_name: 'captcha',
    popup_name: 'chat',
    object_type: 'popup'
  }));
};
export var ymPushViewMesCaptchaDone = function ymPushViewMesCaptchaDone(zoneType) {
  ymPushChatParams(_objectSpread(_objectSpread({}, ymPageSharedData()), {}, {
    account_type: getAuthTypeAnalytics(zoneType),
    action: chatAnalyticsAction.view,
    item_type: 'step',
    step: 'верный ввод капчи',
    popup_name: 'chat',
    object_type: 'popup'
  }));
};
export var ymPushViewMesRetryCaptcha = function ymPushViewMesRetryCaptcha(zoneType) {
  ymPushChatParams(_objectSpread(_objectSpread({}, ymPageSharedData()), {}, {
    account_type: getAuthTypeAnalytics(zoneType),
    action: chatAnalyticsAction.view,
    item_type: 'step',
    step: 'повторный запрос капчи',
    popup_name: 'chat',
    object_type: 'popup'
  }));
};
export var ymPushViewMesErrorCaptcha = function ymPushViewMesErrorCaptcha(zoneType) {
  ymPushChatParams(_objectSpread(_objectSpread({}, ymPageSharedData()), {}, {
    account_type: getAuthTypeAnalytics(zoneType),
    action: chatAnalyticsAction.view,
    action_type: chatAnalyticsAction.error,
    item_type: 'step',
    step: 'Неверный ввод капчи',
    popup_name: 'chat',
    object_type: 'popup'
  }));
};
export var ymPushBlockCaptcha = function ymPushBlockCaptcha(zoneType) {
  ymPushChatParams(_objectSpread(_objectSpread({}, ymPageSharedData()), {}, {
    account_type: getAuthTypeAnalytics(zoneType),
    action: chatAnalyticsAction.view,
    action_type: chatAnalyticsAction.error,
    item_type: 'step',
    step: 'трижды неверный ввод капчи',
    popup_name: 'chat',
    object_type: 'popup'
  }));
};
export var ymPushClickRefreshCaptcha = function ymPushClickRefreshCaptcha(zoneType) {
  ymPushChatParams(_objectSpread(_objectSpread({}, ymPageSharedData()), {}, {
    account_type: getAuthTypeAnalytics(zoneType),
    action: chatAnalyticsAction.click,
    item_type: 'icon',
    icon_name: 'retry',
    popup_name: 'chat',
    object_type: 'popup'
  }));
};
export var ymPushViewHelloMesBot = function ymPushViewHelloMesBot(zoneType) {
  ymPushChatParams(_objectSpread(_objectSpread({}, ymPageSharedData()), {}, {
    account_type: getAuthTypeAnalytics(zoneType),
    action: chatAnalyticsAction.view,
    item_type: 'step',
    step: 'начало диалога с ботом',
    popup_name: 'chat',
    object_type: 'popup'
  }));
};
export var ymPushViewAnswerMesBot = function ymPushViewAnswerMesBot(zoneType) {
  ymPushChatParams(_objectSpread(_objectSpread({}, ymPageSharedData()), {}, {
    account_type: getAuthTypeAnalytics(zoneType),
    action: chatAnalyticsAction.view,
    item_type: 'step',
    step: 'ответ на запрос',
    popup_name: 'chat',
    object_type: 'popup'
  }));
};
export var ymPushViewAnswerENDMesBot = function ymPushViewAnswerENDMesBot(message, zoneType) {
  ymPushChatParams(_objectSpread(_objectSpread({}, ymPageSharedData()), {}, {
    account_type: getAuthTypeAnalytics(zoneType),
    action: chatAnalyticsAction.view,
    item_type: 'message',
    message_text: message,
    step: 'спасибо за обращение',
    popup_name: 'chat',
    object_type: 'popup'
  }));
};
export var ymPushAnswerMesBot = function ymPushAnswerMesBot(message, zoneType) {
  if (message.includes(END_TEXT)) {
    ymPushViewAnswerENDMesBot(message, zoneType);
    return;
  }
  if (zoneType === 'unauthorized') {
    // Проверяем состояние - является ли ответ бота первым в текущей сессии (требуется для Аналитики получения первого сообщения от бота)
    var isNonStart = getIsNonStartAnswerMes();
    if (isNonStart) {
      return;
    }
    if (message.toLowerCase().includes(HELLO_TEXT)) {
      ymPushViewHelloMesBot(zoneType);
    } else {
      ymPushViewAnswerMesBot(zoneType);
    }
    setStageAnswerMes('active');
  }
};

// Attach

export var ymPushClickAttach = function ymPushClickAttach(zoneType) {
  ymPushAttachParams(_objectSpread(_objectSpread({}, ymPageSharedData()), {}, {
    account_type: getAuthTypeAnalytics(zoneType),
    action: chatAnalyticsAction.click,
    item_type: 'icon',
    icon_name: 'attach'
  }));
};
export var ymPushClickAttachInput = function ymPushClickAttachInput(label, zoneType) {
  ymPushAttachParams(_objectSpread(_objectSpread({}, ymPageSharedData()), {}, {
    account_type: getAuthTypeAnalytics(zoneType),
    action: chatAnalyticsAction.click,
    item_type: 'element',
    element_type: label
  }));
};
export var ymPushClickAttachView = function ymPushClickAttachView(label, zoneType) {
  ymPushAttachParams(_objectSpread(_objectSpread({}, ymPageSharedData()), {}, {
    account_type: getAuthTypeAnalytics(zoneType),
    action: chatAnalyticsAction.click,
    item_type: 'message',
    element_type: label
  }));
};
export var ymPushSendAttach = function ymPushSendAttach(label, zoneType) {
  ymPushAttachParams(_objectSpread(_objectSpread({}, ymPageSharedData()), {}, {
    account_type: getAuthTypeAnalytics(zoneType),
    action: chatAnalyticsAction.click,
    item_type: 'icon',
    icon_type: 'send',
    element_type: label
  }));
};
export var ymPushResendAttach = function ymPushResendAttach(label, zoneType) {
  ymPushAttachParams(_objectSpread(_objectSpread({}, ymPageSharedData()), {}, {
    account_type: getAuthTypeAnalytics(zoneType),
    action: chatAnalyticsAction.click,
    item_type: 'message',
    action_type: 'retry',
    element_type: label
  }));
};
export var ymPushRefreshAttach = function ymPushRefreshAttach(label) {
  ymPushAttachParams(_objectSpread(_objectSpread({}, ymPageSharedData()), {}, {
    account_type: AuthTypeAnalytics.az,
    action: chatAnalyticsAction.click,
    item_type: 'icon',
    action_type: 'reload',
    element_type: label
  }));
};
export var ymPushSendClickQuickButton = function ymPushSendClickQuickButton(text, typeBtn, zoneType) {
  ymPushChatParams(_objectSpread(_objectSpread({}, ymPageSharedData()), {}, {
    account_type: getAuthTypeAnalytics(zoneType),
    action: chatAnalyticsAction.click,
    item_type: 'button',
    button_text: text,
    block_name: typeBtn,
    popup_name: 'chat',
    object_type: 'popup'
  }));
};
export var ymPushSendViewQuickButton = function ymPushSendViewQuickButton(list, typeBtn, zoneType) {
  ymPushChatParams(_objectSpread(_objectSpread({}, ymPageSharedData()), {}, {
    account_type: getAuthTypeAnalytics(zoneType),
    action: chatAnalyticsAction.view,
    item_type: 'block',
    button: list,
    block_name: typeBtn,
    popup_name: 'chat',
    object_type: 'popup'
  }));
};